export interface Movie {
  id: string;
  title: string;
  poster: string;
  backdrop?: string;
  year: number;
  releaseDate: string;
  types: string[];
  region: string;
  director: string;
  cast: string[];
  duration: number;
  rating: number;
  heat: number;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: "m1",
    title: "星际远征",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20facing%20a%20massive%20starship%20above%20a%20blue%20planet%2C%20deep%20navy%20and%20orange%20glow%2C%20dramatic%20rim%20lighting%2C%20epic%20sci-fi%20tone%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=mp-poster-m1&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20spaceship%20fleet%20traveling%20toward%20a%20glowing%20blue%20planet%2C%20deep%20navy%20space%20with%20warm%20orange%20nebula%20highlights%2C%20dramatic%20atmospheric%20lighting%2C%20moody%20film%20still%2C%20no%20text&width=1600&height=900&seq=mp-hero-m1&orientation=landscape",
    year: 2025,
    releaseDate: "2025-08-15",
    types: ["科幻", "冒险"],
    region: "美国",
    director: "艾伦·沃克",
    cast: ["凯文·马斯", "艾琳·诺曼", "周牧云"],
    duration: 148,
    rating: 8.6,
    heat: 9820,
    synopsis: "当人类首次接收到来自半人马座的神秘信号，一支由顶尖科学家与飞行员组成的远征队踏上星际旅程。他们必须在资源耗尽之前解开信号背后的真相，却发现宇宙深处隐藏着远比想象更庞大的秘密。",
  },
  {
    id: "m2",
    title: "暗夜追踪",
    poster: "https://readdy.ai/api/search-image?query=Gritty%20cinematic%20movie%20poster%20of%20a%20lone%20detective%20in%20a%20rainy%20neon%20city%20alley%2C%20deep%20blue%20shadows%20with%20orange%20streetlight%20glow%2C%20moody%20crime%20thriller%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m2&orientation=portrait",
    year: 2024,
    releaseDate: "2024-11-02",
    types: ["动作", "犯罪"],
    region: "中国",
    director: "林沉",
    cast: ["顾南舟", "苏以宁", "郑川"],
    duration: 122,
    rating: 8.1,
    heat: 9110,
    synopsis: "一桩连环失踪案将刑警顾南舟拖入城市最黑暗的角落。随着线索逐渐串联，他发现真相与多年前未解的旧案紧密相连，而兇手可能一直就在他身边。",
  },
  {
    id: "m3",
    title: "时光信笺",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20a%20young%20couple%20under%20autumn%20maple%20leaves%20holding%20an%20old%20letter%2C%20soft%20warm%20orange%20and%20cream%20tones%2C%20gentle%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=mp-poster-m3&orientation=portrait",
    year: 2025,
    releaseDate: "2025-05-20",
    types: ["爱情", "剧情"],
    region: "韩国",
    director: "朴志勋",
    cast: ["韩书妍", "李在民", "金敏瑞"],
    duration: 118,
    rating: 8.3,
    heat: 8640,
    synopsis: "一封迟到十年的信件，让两个早已走向不同人生的人重新被命运牵连。他们在旧时光的碎片里，重新寻找当年说不出口的那句话。",
  },
  {
    id: "m4",
    title: "爆笑一家亲",
    poster: "https://readdy.ai/api/search-image?query=Bright%20playful%20comedy%20movie%20poster%20of%20a%20chaotic%20happy%20family%20in%20a%20colorful%20living%20room%2C%20warm%20orange%20and%20teal%20accents%2C%20cheerful%20lighting%2C%20no%20text&width=600&height=900&seq=mp-poster-m4&orientation=portrait",
    year: 2024,
    releaseDate: "2024-09-30",
    types: ["喜剧", "家庭"],
    region: "中国",
    director: "王小满",
    cast: ["陈多多", "刘喜", "赵一乐"],
    duration: 105,
    rating: 7.6,
    heat: 7980,
    synopsis: "一次意外的家庭旅行，把三代人塞进了一辆老旧的房车里。鸡飞狗跳的旅程中，他们重新学会了如何好好说话、好好相爱。",
  },
  {
    id: "m5",
    title: "深海迷航",
    poster: "https://readdy.ai/api/search-image?query=Mysterious%20movie%20poster%20of%20a%20submarine%20descending%20into%20a%20glowing%20deep%20sea%20trench%2C%20dark%20teal%20water%20with%20orange%20bioluminescent%20lights%2C%20suspenseful%20sci-fi%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m5&orientation=portrait",
    year: 2025,
    releaseDate: "2025-07-11",
    types: ["科幻", "悬疑"],
    region: "美国",
    director: "玛莎·科尔",
    cast: ["丹尼尔·雷", "艾米·肖", "维克多·陈"],
    duration: 132,
    rating: 8.0,
    heat: 8760,
    synopsis: "一支深海科考队在海沟底部发现了一座不该存在的建筑。随着探索深入，他们开始怀疑，真正被困在黑暗里的，究竟是谁。",
  },
  {
    id: "m6",
    title: "侠影江湖",
    poster: "https://readdy.ai/api/search-image?query=Wuxia%20movie%20poster%20of%20a%20swordsman%20standing%20on%20a%20misty%20cliff%20at%20dusk%2C%20deep%20indigo%20mountains%20with%20warm%20orange%20sunset%2C%20ink%20painting%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=mp-poster-m6&orientation=portrait",
    year: 2023,
    releaseDate: "2023-12-18",
    types: ["武侠", "动作"],
    region: "中国",
    director: "陆孤城",
    cast: ["萧亦寒", "白清歌", "荆无涯"],
    duration: 138,
    rating: 8.4,
    heat: 8420,
    synopsis: "少年剑客背负师门血仇踏入江湖，却在一次次生死抉择中明白，真正的侠义从不是快意恩仇，而是守住心中那点不肯熄灭的光。",
  },
  {
    id: "m7",
    title: "机械黎明",
    poster: "https://readdy.ai/api/search-image?query=Futuristic%20movie%20poster%20of%20a%20humanoid%20robot%20awakening%20in%20a%20destroyed%20city%2C%20steel%20grey%20and%20orange%20spark%20highlights%2C%20epic%20sci-fi%20action%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m7&orientation=portrait",
    year: 2025,
    releaseDate: "2025-06-06",
    types: ["科幻", "动作"],
    region: "中国",
    director: "高远",
    cast: ["沈澈", "程知夏", "梁牧"],
    duration: 141,
    rating: 7.9,
    heat: 8890,
    synopsis: "当第一台拥有自我意识的机械体在废墟中睁开双眼，人类与机器的边界彻底模糊。一个工程师必须在战争爆发前，决定谁才配拥有未来。",
  },
  {
    id: "m8",
    title: "午夜旅馆",
    poster: "https://readdy.ai/api/search-image?query=Eerie%20movie%20poster%20of%20a%20dimly%20lit%20old%20hotel%20corridor%20at%20midnight%20with%20one%20glowing%20orange%20door%2C%20deep%20blue%20shadows%2C%20creepy%20suspense%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m8&orientation=portrait",
    year: 2024,
    releaseDate: "2024-10-25",
    types: ["悬疑", "惊悚"],
    region: "日本",
    director: "山田凉介",
    cast: ["佐藤绫", "小林海斗", "中村雪"],
    duration: 112,
    rating: 7.7,
    heat: 7340,
    synopsis: "一场暴雪把五名旅客困在山路旁的老旅馆。午夜十二点，走廊尽头那扇无人敢开的门，第一次自己打开了。",
  },
  {
    id: "m9",
    title: "云上之境",
    poster: "https://readdy.ai/api/search-image?query=Whimsical%20animated%20movie%20poster%20of%20a%20girl%20riding%20a%20giant%20paper%20bird%20above%20floating%20cloud%20islands%2C%20soft%20pastel%20and%20warm%20orange%20sky%2C%20dreamy%20fantasy%20style%2C%20no%20text&width=600&height=900&seq=mp-poster-m9&orientation=portrait",
    year: 2025,
    releaseDate: "2025-04-04",
    types: ["动画", "奇幻"],
    region: "中国",
    director: "叶青禾",
    cast: ["配音：林月", "配音：周小满"],
    duration: 96,
    rating: 8.5,
    heat: 8250,
    synopsis: "少女阿黎意外来到漂浮在云层之上的世界。为了找回回家的路，她必须收集散落在岛屿间的星光，也一点点找回了勇气。",
  },
  {
    id: "m10",
    title: "追风少年",
    poster: "https://readdy.ai/api/search-image?query=Inspirational%20sports%20movie%20poster%20of%20a%20teenage%20runner%20sprinting%20on%20a%20track%20at%20golden%20hour%2C%20warm%20orange%20sun%20and%20blue%20sky%2C%20energetic%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=mp-poster-m10&orientation=portrait",
    year: 2024,
    releaseDate: "2024-08-08",
    types: ["剧情", "运动"],
    region: "中国",
    director: "穆云川",
    cast: ["夏小野", "苏禾", "老周"],
    duration: 124,
    rating: 8.2,
    heat: 7690,
    synopsis: "小镇少年为了兑现与父亲的约定，加入濒临解散的田径队。在一次次跌倒与冲刺中，他跑出了自己的赛道，也追上了曾经逃跑的自己。",
  },
  {
    id: "m11",
    title: "城市之光",
    poster: "https://readdy.ai/api/search-image?query=Neo-noir%20movie%20poster%20of%20a%20man%20standing%20on%20a%20rooftop%20overlooking%20a%20glittering%20city%20at%20night%2C%20deep%20blue%20skyline%20with%20orange%20window%20lights%2C%20quiet%20dramatic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m11&orientation=portrait",
    year: 2023,
    releaseDate: "2023-11-24",
    types: ["犯罪", "剧情"],
    region: "中国",
    director: "夏言之",
    cast: ["方正", "黎晚", "许沉"],
    duration: 130,
    rating: 8.0,
    heat: 7010,
    synopsis: "一座繁华都市的角落，总有一些人被光遗忘。退休警察与夜班出租车司机在命运交错的那个夜晚，做出了改变彼此人生的选择。",
  },
  {
    id: "m12",
    title: "樱花之约",
    poster: "https://readdy.ai/api/search-image?query=Delicate%20romance%20movie%20poster%20of%20a%20couple%20standing%20under%20blooming%20cherry%20blossoms%20by%20a%20river%2C%20soft%20pink%20and%20warm%20cream%20tones%2C%20tender%20cinematic%20light%2C%20no%20text&width=600&height=900&seq=mp-poster-m12&orientation=portrait",
    year: 2025,
    releaseDate: "2025-03-28",
    types: ["爱情", "剧情"],
    region: "日本",
    director: "新垣优",
    cast: ["森川葵", "藤井翔", "石原理"],
    duration: 116,
    rating: 8.1,
    heat: 7480,
    synopsis: "每年樱花季，两人都会在同一座桥上相遇。多年以后，当他们各自带着心事归来，才发现有些约定从未真正失效。",
  },
  {
    id: "m13",
    title: "幽灵古堡",
    poster: "https://readdy.ai/api/search-image?query=Gothic%20horror%20movie%20poster%20of%20an%20abandoned%20castle%20on%20a%20stormy%20night%20lit%20by%20one%20orange%20window%2C%20eerie%20blue%20fog%2C%20dark%20scary%20atmosphere%2C%20no%20text&width=600&height=900&seq=mp-poster-m13&orientation=portrait",
    year: 2024,
    releaseDate: "2024-10-31",
    types: ["恐怖", "悬疑"],
    region: "美国",
    director: "格雷格·希尔",
    cast: ["诺拉·佩恩", "托马斯·李", "艾拉·沃德"],
    duration: 108,
    rating: 7.4,
    heat: 6880,
    synopsis: "一群历史系学生进入废弃的古堡做课题考察，却发现每一面镜子背后，都藏着一段不愿被记起的往事。",
  },
  {
    id: "m14",
    title: "极地救援",
    poster: "https://readdy.ai/api/search-image?query=Survival%20adventure%20movie%20poster%20of%20a%20small%20rescue%20team%20crossing%20a%20frozen%20ice%20field%2C%20pale%20blue%20ice%20with%20warm%20orange%20sun%20low%20on%20the%20horizon%2C%20heroic%20cinematic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m14&orientation=portrait",
    year: 2025,
    releaseDate: "2025-01-17",
    types: ["冒险", "剧情"],
    region: "美国",
    director: "卡特·布莱恩",
    cast: ["杰克·奥尔森", "米娅·罗斯", "汉斯·克鲁格"],
    duration: 135,
    rating: 8.3,
    heat: 8020,
    synopsis: "南极科考站遭遇百年一遇的极寒风暴，一支临时拼凑的救援队必须在零下六十度的绝境中穿越冰原，把困在深处的人带回家。",
  },
  {
    id: "m15",
    title: "魔法学徒",
    poster: "https://readdy.ai/api/search-image?query=Fantasy%20family%20movie%20poster%20of%20a%20young%20apprentice%20holding%20a%20glowing%20orange%20spellbook%20in%20a%20candlelit%20study%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20magical%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=mp-poster-m15&orientation=portrait",
    year: 2024,
    releaseDate: "2024-12-06",
    types: ["奇幻", "家庭"],
    region: "英国",
    director: "奥利弗·格兰特",
    cast: ["艾米·卡特", "卢卡斯·格林", "费奥娜·布莱克"],
    duration: 119,
    rating: 7.8,
    heat: 7120,
    synopsis: "胆小的小学徒意外打开了被封印的古老咒书，为了弥补过失，他必须踏上寻找三种魔法元素的旅程，并第一次学会相信自己的力量。",
  },
  {
    id: "m16",
    title: "无声告白",
    poster: "https://readdy.ai/api/search-image?query=Quiet%20mystery%20movie%20poster%20of%20a%20woman%20standing%20by%20a%20rain-streaked%20window%20looking%20out%2C%20muted%20blue%20greys%20with%20a%20warm%20orange%20lamp%2C%20emotional%20cinematic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m16&orientation=portrait",
    year: 2023,
    releaseDate: "2023-10-13",
    types: ["悬疑", "剧情"],
    region: "韩国",
    director: "崔恩熙",
    cast: ["宋智雅", "姜道贤", "尹书俊"],
    duration: 126,
    rating: 8.2,
    heat: 7260,
    synopsis: "一位失语症女子成为一桩悬案唯一的目击者。为了说出真相，她必须用一个又一个沉默的细节，拼凑出那个夜晚完整的模样。",
  },
  {
    id: "m17",
    title: "沙海孤舟",
    poster: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20movie%20poster%20of%20a%20traveler%20crossing%20an%20endless%20orange%20sand%20dune%20sea%20with%20a%20ruined%20spire%20in%20the%20distance%2C%20hazy%20blue%20sky%2C%20epic%20desolate%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m17&orientation=portrait",
    year: 2025,
    releaseDate: "2025-02-21",
    types: ["冒险", "科幻"],
    region: "美国",
    director: "伊莎贝拉·冯",
    cast: ["亚瑟·凯恩", "蕾娜·福斯特", "奇科·门德斯"],
    duration: 143,
    rating: 7.9,
    heat: 7640,
    synopsis: "在资源枯竭的遥远未来，一名拾荒者驾驶着最后的沙舟穿越死亡沙漠，只为把他捡到的一颗种子，送到传说中还有水的地方。",
  },
  {
    id: "m18",
    title: "王牌特工队",
    poster: "https://readdy.ai/api/search-image?query=Action%20comedy%20movie%20poster%20of%20a%20mismatched%20spy%20squad%20posing%20with%20cool%20props%2C%20sleek%20dark%20suits%20with%20bright%20orange%20accent%20lighting%2C%20playful%20stylish%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m18&orientation=portrait",
    year: 2024,
    releaseDate: "2024-07-19",
    types: ["动作", "喜剧"],
    region: "中国",
    director: "钱多多",
    cast: ["雷小虎", "乔乔", "老K"],
    duration: 111,
    rating: 7.5,
    heat: 7580,
    synopsis: "四个被淘汰的“问题特工”被临时凑成一支小队，去执行一桩谁都不看好的任务。结果，他们用最离谱的方式，完成了一次最正经的拯救。",
  },
  {
    id: "m19",
    title: "月光诗人",
    poster: "https://readdy.ai/api/search-image?query=Artistic%20romance%20movie%20poster%20of%20a%20melancholic%20writer%20on%20a%20Paris%20balcony%20under%20moonlight%2C%20soft%20deep%20blue%20night%20with%20warm%20orange%20window%20glow%2C%20literary%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=mp-poster-m19&orientation=portrait",
    year: 2023,
    releaseDate: "2023-09-15",
    types: ["爱情", "文艺"],
    region: "法国",
    director: "朱利安·莫罗",
    cast: ["艾洛伊丝", "雷米·杜邦", "卡米耶"],
    duration: 113,
    rating: 7.9,
    heat: 6420,
    synopsis: "一位坚持用纸笔写作的落魄诗人，与一位靠算法生活的编辑相遇。他们争论诗歌是否还有意义，却在辩论中读懂了彼此。",
  },
  {
    id: "m20",
    title: "未来都市",
    poster: "https://readdy.ai/api/search-image?query=Cyberpunk%20movie%20poster%20of%20a%20neon%20megacity%20skyline%20with%20a%20silhouetted%20figure%20on%20a%20hoverbike%2C%20deep%20blue%20night%20with%20vivid%20orange%20and%20magenta%20neon%2C%20futuristic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m20&orientation=portrait",
    year: 2025,
    releaseDate: "2025-09-05",
    types: ["科幻", "赛博"],
    region: "日本",
    director: "高桥凛",
    cast: ["苍井陆", "水野纱织", "黑泽透"],
    duration: 129,
    rating: 8.0,
    heat: 8340,
    synopsis: "在一切都由数据支配的巨型都市里，一名记忆修复师接到了一份不该存在的委托——修复一段从未被人拥有过的记忆。",
  },
  {
    id: "m21",
    title: "迷雾山谷",
    poster: "https://readdy.ai/api/search-image?query=Atmospheric%20thriller%20movie%20poster%20of%20a%20tiny%20village%20lost%20in%20thick%20blue%20fog%20with%20a%20single%20warm%20orange%20lantern%20glow%2C%20mysterious%20tense%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m21&orientation=portrait",
    year: 2024,
    releaseDate: "2024-06-14",
    types: ["悬疑", "恐怖"],
    region: "中国",
    director: "白砚",
    cast: ["秦岭", "顾晚", "石头"],
    duration: 117,
    rating: 7.6,
    heat: 6900,
    synopsis: "返乡青年发现，每当山谷起雾，村里就会有人失踪。为了找回失踪的妹妹，他决定在下一个雾夜，独自走进那片白茫茫的深谷。",
  },
  {
    id: "m22",
    title: "快乐星球",
    poster: "https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20poster%20of%20a%20friendly%20round%20robot%20and%20kids%20on%20a%20rainbow%20planet%2C%20bright%20orange%20and%20sky%20blue%20playful%20palette%2C%20cheerful%20kids%20style%2C%20no%20text&width=600&height=900&seq=mp-poster-m22&orientation=portrait",
    year: 2023,
    releaseDate: "2023-06-01",
    types: ["动画", "喜剧"],
    region: "中国",
    director: "麦浪",
    cast: ["配音：小豆", "配音：圆圆"],
    duration: 92,
    rating: 8.0,
    heat: 7050,
    synopsis: "来自快乐星球的小机器人意外降落在城市天台，与三个孩子成为朋友。他们一起把平凡的日子，过成了一整个夏天的冒险。",
  },
  {
    id: "m23",
    title: "帝国黄昏",
    poster: "https://readdy.ai/api/search-image?query=Historical%20epic%20movie%20poster%20of%20a%20king%20standing%20in%20a%20vast%20stone%20throne%20hall%20at%20sunset%2C%20rich%20deep%20blue%20shadows%20with%20warm%20orange%20light%20beams%2C%20grand%20dramatic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m23&orientation=portrait",
    year: 2025,
    releaseDate: "2025-10-01",
    types: ["历史", "剧情"],
    region: "英国",
    director: "亨利·阿什顿",
    cast: ["爱德华·克莱", "维多利亚·格雷", "詹姆斯·霍普"],
    duration: 152,
    rating: 8.6,
    heat: 8560,
    synopsis: "一个庞大帝国在最后十年里的崩塌与挣扎。曾经不可一世的君主，必须面对自己亲手种下的每一个选择，以及即将到来的漫长黄昏。",
  },
  {
    id: "m24",
    title: "绝地反击",
    poster: "https://readdy.ai/api/search-image?query=War%20movie%20poster%20of%20soldiers%20advancing%20through%20a%20smoky%20ruined%20town%20at%20dawn%2C%20desaturated%20blue%20grey%20with%20warm%20orange%20explosion%20glow%2C%20intense%20dramatic%20tone%2C%20no%20text&width=600&height=900&seq=mp-poster-m24&orientation=portrait",
    year: 2024,
    releaseDate: "2024-12-20",
    types: ["动作", "战争"],
    region: "中国",
    director: "雷振国",
    cast: ["赵铁", "孙烈", "林小雨"],
    duration: 132,
    rating: 8.1,
    heat: 7930,
    synopsis: "一支被切断补给的小分队在敌后坚守阵地。弹尽粮绝之际，他们做出了一个足以改变整场战役走向的决定。",
  },
];